<template>
    <v-card>
      <div>
        <div>
          <v-table>
            <thead>
              <tr>
                <th></th>
                <th>Вид деятельности</th>
                <th>Используемые средства</th>
                <th>Место прохождения</th>
                <th>Учебная практика</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pract, index) in Practice" :key="index">
                <td>
                  <span>{{ index + 1 }}</span>
                </td>
                <td>
                  <v-textarea
                    auto-grow
                    rows="1"
                    v-model="pract.typeActivity"
                  ></v-textarea>
                </td>
                <td>
                  <v-textarea
                    auto-grow
                    rows="1"
                    v-model="pract.tools"
                  ></v-textarea>
                </td>
                <td>
                  <v-textarea
                    auto-grow
                    rows="1"
                    v-model="pract.location"
                  ></v-textarea>
                </td>
                <td style="width: 3px">
                  <v-switch
                    v-model="pract.is_educational"
                    color="success"
                    hide-details
                    @update:modelValue="
                      getOrganizationInfo(pract.is_educational, index, Practice)
                    "
                  ></v-switch>
                </td>
                <td>
                  <v-icon
                    color="red darken-1"
                    @click="deleteRow(index, Practice)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
                <td>
                  <v-icon
                    color="blue-grey-darken-3"
                    @click="moveUp(index, Practice)"
                  >
                    mdi-arrow-up-thin
                  </v-icon>
                  <v-spacer></v-spacer>
                  <v-icon
                    color="blue-grey-darken-3"
                    @click="moveDown(index, Practice)"
                  >
                    mdi-arrow-down-thin
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
      <v-btn block @click="addRow('Practice')">
        <v-icon color="green darken-1">mdi-plus</v-icon>
      </v-btn>
    </v-card>
</template>
<script>
export default {
  data() {
    return {
      tab: null,
      Practice: [],
      snackbar: false,
      color: "primary",
      text: "",
      abortControl: [],
      keyPressedmsAgo: false,
      sendingDataHandler: false,
    };
  },
  props: {
    student_id: null,
    practiceData: null
  },
  watch: {
    Practice: {
      handler(val) {
        this.keyPressedmsAgo = true;
        if (!this.sendingDataHandler) {
          this.sendingDataHandler = setInterval(() => {
            if (!this.keyPressedmsAgo) {
              this.savePractice();
              clearInterval(this.sendingDataHandler);
              this.sendingDataHandler = false;
            }
            this.keyPressedmsAgo = false;
          }, 500);
        }
      },
      deep: true,
    },
    practiceData(){
      this.viewPracticeData();
    }
  },
  methods: {
    addRow(flag) {
      if (flag == "Practice") {
        this.Practice.push({
          typeActivity: "",
          tools: "",
          location: "",
          is_educational: false,
        });
      }
    },
    deleteRow(index, mass) {
      mass.splice(index, 1);
    },
    moveUp(index, mass) {
      const temp = mass[index];
      mass.splice(index, 1);
      mass.splice(index - 1, 0, temp);
    },
    moveDown(index, mass) {
      const temp = mass[index];
      mass.splice(index, 1);
      mass.splice(index + 1, 0, temp);
    },
    getOrganizationInfo(flag, index, mass) {
      if (flag == true) {
        this.axios
          .post(
            this.$model.wwwroot +
              "/procollege/manage_groups/gradesBook2/practicalTraining/getOrganizationInfo"
          )
          .then((response) => {
            mass[index].location =
              response.data.organization_name + "\n\r" + response.data.inn;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        mass[index].location = "";
      }
    },
    savePractice() {
      //уже отправленные и еще не обработанные запросы не интересны
      let abortControl_;
      while ((abortControl_ = this.abortControl.pop())) {
        abortControl_.abort();
      }
      //------------------------------------------
      abortControl_ = new AbortController();
      this.abortControl.push(abortControl_);
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/gradesBook2/practicalTraining/setPracticalTraining",
          new URLSearchParams({
            student_id: this.student_id,
            data: JSON.stringify(this.Practice),
          }),
          {
            signal: abortControl_.signal,
          }
        )
        .then((response) => {
          this.abortControl.pop();
        })
        .catch((error) => {
          this.abortControl.pop();
          console.log(error);
        });
    },
    viewPracticeData(){
      this.Practice = [];
      for (var i in this.practiceData) {
        this.Practice.push({
          typeActivity: this.practiceData[i].typeActivity,
          tools: this.practiceData[i].tools,
          location: this.practiceData[i].location,
          is_educational: this.practiceData[i].is_educational
        });
      }
    }
  },
};
</script>